import FormControl from '@mui/material/FormControl'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormGroup from '@mui/material/FormGroup'
import {Text} from '../1elements'
import Box from '@mui/material/Box'

const CheckBoxList = ({list, setList, labelKey}) => {
    const handleChange = (event, index) => {
        const copy = [...list]
        copy[index].selected = !copy[index].selected
        setList(copy);
    };

    return (
        <Box sx={{ '& > *': { width: '100%' } }}>
            <FormControl component="fieldset">
                <FormGroup sx={{ display: 'flex', flexDirection: 'column', flexWrap: 'nowrap', maxHeight: '300px', overflowY: 'auto' }}>
                    {
                        list.map((item, index)=>(
                            list[index].selected !== undefined
                                ? (<FormControlLabel
                                    key={item[labelKey] || index}
                                    control={<Checkbox checked={list[index].selected}
                                                       onChange={(e)=>handleChange(e, index)} name={item[labelKey]} />}
                                    label={item[labelKey]}
                                    sx={{ marginLeft: '5px' }}
                                />)
                                : (
                                    <Text key={item[labelKey] || index} type={'selectOwnerModalHeader'}>{item[labelKey]}</Text>
                                )
                        ))
                    }
                </FormGroup>
            </FormControl>
        </Box>
    )
}

export default CheckBoxList
